import { Link } from 'react-router-dom';

const cards = [
  {
    title: 'Personal Insurance',
    href: '/insurance-solutions#personal',
    img: 'https://b3533217.smushcdn.com/3533217/wp-content/uploads/2024/12/Personal-Insurance-Portrait-of-Cheerful-Parents-Having-Fun-Playing-Outside-in-the-Backyard-with-Their-Two-Girls.jpg?lossy=2&strip=1&webp=1',
  },
  {
    title: 'Business Insurance',
    href: '/insurance-solutions#business',
    img: 'https://b3533217.smushcdn.com/3533217/wp-content/uploads/2024/12/Business-Insurance-Group-of-Four-Employees-Having-a-Meeting-in-a-Small-Office.jpg?lossy=2&strip=1&webp=1',
  },
  {
    title: 'Insurance by Industry',
    href: '/insurance-solutions#industry',
    img: 'https://b3533217.smushcdn.com/3533217/wp-content/uploads/2024/12/Insurance-by-Industry-Scenic-View-of-a-Red-Barn-on-a-Small-Farm-in-Georgia-During-the-Fall-on-a-Sunny-Day.jpg?lossy=2&strip=1&webp=1',
  },
];

export default function InsuranceCards() {
  return (
    <section className="pb-0">
      {/* Header */}
      <div className="text-center py-14 px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-[#0b2240] mb-3">
          The Solution to Your Insurance Needs
        </h2>
        <p className="text-gray-500 text-base max-w-2xl mx-auto">
          We offer a variety of{' '}
          <Link to="/insurance-solutions#personal" className="text-[#3072b7] hover:underline">personal insurance</Link>
          {' '}and{' '}
          <Link to="/insurance-solutions#business" className="text-[#3072b7] hover:underline">business insurance</Link>
          {' '}solutions to help you protect what matters most.
        </p>
      </div>

      {/* 3-column image cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3">
        {cards.map((card) => (
          <Link
            key={card.title}
            to={card.href}
            className="group relative overflow-hidden block min-h-[380px] md:min-h-[450px]"
          >
            <img
              src={card.img}
              alt={card.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent group-hover:from-[#3072b7]/80 transition-all duration-400" />
            {/* Title */}
            <div className="absolute bottom-0 left-0 right-0 p-7">
              <h3 className="text-white text-2xl font-bold">{card.title}</h3>
            </div>
          </Link>
        ))}
      </div>

      {/* More Insurance Products toggle */}
      <div className="bg-white px-8 md:px-16 py-6">
        <MoreProducts />
      </div>
    </section>
  );
}

function MoreProducts() {
  return (
    <div className="border border-[#9cbde5]/40 rounded-md overflow-hidden">
      <details className="group">
        <summary className="flex items-center gap-3 px-6 py-4 cursor-pointer text-[#3072b7] font-semibold text-base hover:bg-[#f8f9fc] transition-colors list-none">
          <i className="ri-add-circle-line text-xl group-open:hidden" />
          <i className="ri-indeterminate-circle-line text-xl hidden group-open:inline" />
          More Insurance Products
        </summary>
        <div className="px-6 pb-6 pt-2 grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-[#9cbde5]/30">
          {[
            {
              title: 'Personal Insurance',
              href: '/insurance-solutions#personal',
              items: ['Home Insurance', 'Auto Insurance', 'Individual Life Insurance', 'Renters Insurance', 'Umbrella Insurance'],
            },
            {
              title: 'Business Insurance',
              href: '/insurance-solutions#business',
              items: ['Professional Liability Insurance', 'General Liability Insurance', "Workers' Compensation Insurance", 'Business Auto Insurance', 'Commercial Property Insurance'],
            },
            {
              title: 'Insurance by Industry',
              href: '/insurance-solutions#industry',
              items: ['Farm Insurance', 'Contractor Insurance', 'Restaurant Insurance', 'Manufacturer Insurance', 'Landscaping Services Insurance'],
            },
          ].map((col) => (
            <div key={col.title} className="border border-[#9cbde5]/40 rounded-md p-5">
              <h4 className="font-bold text-[#0b2240] mb-2">
                <Link to={col.href} className="hover:text-[#3072b7] transition-colors">{col.title}</Link>
              </h4>
              <div className="w-full h-px bg-gradient-to-r from-[#3072b7] to-[#9cbde5] mb-3" />
              <ul className="space-y-1.5">
                {col.items.map((item) => (
                  <li key={item}>
                    <Link to={col.href} className="text-sm text-gray-600 hover:text-[#3072b7] transition-colors">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </details>
    </div>
  );
}
